module.exports = __webpack_public_path__ + "img/feat_fast.450ac78d.png";